import React from 'react';

type StickyFooterProps = {
    onSlideSave: () => void;
};

const StickyFooter = ({ onSlideSave }: StickyFooterProps) => {
    return (
        <footer className="fixed bottom-0 left-0 z-20 w-full p-2 bg-white border-t border-gray-200 shadow md:flex md:items-center md:justify-between md:p-4">
            <a href="/docs/panoramavft.html" target='_blank' className='text-blue-500 hover:underline hover:text-blue-700'>Documentation</a>
            <button
                type="button"
                className="text-white bg-primary-blue hover:bg-blue-800 focus:outline-none font-medium rounded-lg text-sm px-2.5 py-2 text-center inline-flex items-center me-2"
                onClick={onSlideSave}>Save slide
            </button>
        </footer>
    )
}

export default StickyFooter;


